import { render, staticRenderFns } from "./TripleLiteratureEvidence.vue?vue&type=template&id=29cc0877&"
import script from "./TripleLiteratureEvidence.vue?vue&type=script&lang=ts&"
export * from "./TripleLiteratureEvidence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports